import { render, staticRenderFns } from "./CoursewareImportWidget.vue?vue&type=template&id=1b19a9f4&"
import script from "./CoursewareImportWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareImportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports